import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { HelpCircle, BookOpen } from "lucide-react";

export const HelpTip = ({ cat, ids, label = "Aiuto" }) => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [items, setItems] = useState([]), [loading, setLoading] = useState(false), [error, setError] = useState("");
  const filterIds = ids?.join(",") || "";
  useEffect(() => {
    if (!open) return;
    const c = new AbortController(); setLoading(true); setItems([]); setError("");
    api.get("/help/articles", { params: cat ? { category: cat } : {}, signal: c.signal }).then(({ data }) => setItems(data.items.filter((item) => !filterIds || filterIds.split(",").includes(item.slug)))).catch(() => { if (!c.signal.aborted) setError("Guida non disponibile."); }).finally(() => { if (!c.signal.aborted) setLoading(false); });
    return () => c.abort();
  }, [open, cat, filterIds]);
  const catLabel = label;

  return (
    <>
      <button onClick={() => setOpen(true)} title="Come funziona?" aria-label="Aiuto"
        className="inline-flex items-center justify-center w-8 h-8 rounded-full border border-border text-muted-foreground hover:text-primary hover:border-primary transition-colors shrink-0"
        data-testid={`help-tip-${cat || "custom"}`}>
        <HelpCircle className="w-4 h-4" />
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-h-[80vh] overflow-y-auto" data-testid="help-tip-dialog">
          <DialogHeader><DialogTitle className="flex items-center gap-2"><BookOpen className="w-4 h-4 text-primary" /> {catLabel}</DialogTitle></DialogHeader>
          <div className="space-y-4">
            {loading && <p data-testid="help-tip-loading">Caricamento…</p>}{error && <p role="alert" data-testid="help-tip-error">{error}</p>}
            {!loading && !error && items.length === 0 && <p className="text-sm text-muted-foreground">Nessuna voce disponibile.</p>}
            {items.map((it) => (
              <div key={it.id} className="space-y-1" data-testid={`help-tip-item-${it.id}`}>
                <p className="font-medium text-sm">{it.question}</p>
                <p className="text-sm text-muted-foreground leading-relaxed">{it.answer}</p>
              </div>
            ))}
            <Button variant="outline" className="w-full gap-2" onClick={() => { setOpen(false); navigate(`/app/guida${cat ? `?cat=${cat}` : ""}`); }} data-testid="help-tip-open-guide">
              <BookOpen className="w-4 h-4" /> Apri la Guida completa
            </Button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};
